import { questionsExtraData } from '../constants/Questions';

export const composeExtraDataForQuestion = (question = {}) =>
  Object.assign({}, question, questionsExtraData[question.id]);
